import React from 'react';
import './DataPaginationBanner.scss';

const fmt = (n) => (typeof n === 'number' ? n.toLocaleString() : n);

const STATUS_LABELS = {
  loading: 'Loading data…',
  'grid-refreshing': 'Table refreshing…',
  'chart-refreshing': 'Chart refreshing…',
};

export default function DataPaginationBanner({
  status = 'ready',
  loadedRows,
  totalCount,
  hasMoreResults,
  onLoadMore,
}) {
  const isBusy = status !== 'ready';
  const showCount = typeof totalCount === 'number' && totalCount > 0;
  const canLoadMore = status === 'ready' && hasMoreResults;

  return (
    <div className="data-pagination-banner" role="status" aria-live="polite">
      <span className="data-pagination-banner__count">
        {isBusy ? (
          <>
            <span className="data-pagination-banner__spinner" aria-hidden="true" />
            <span>{STATUS_LABELS[status] ?? 'Working…'}</span>
          </>
        ) : showCount ? (
          <>
            Showing <strong>{fmt(loadedRows)}</strong> of <strong>{fmt(totalCount)}</strong> rows
          </>
        ) : (
          <span className="data-pagination-banner__muted">No data loaded</span>
        )}
      </span>
      {canLoadMore && (
        <button
          type="button"
          className="data-pagination-banner__button"
          onClick={onLoadMore}
        >
          Load more
        </button>
      )}
    </div>
  );
}
